var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 105,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1630_2668)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 52.348,
    r: 52.348,
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__filter0_dd_1630_2668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.522,
    y: 18.977,
    width: 143.957,
    height: 53.657,
    rx: 3.926,
    fill: "url(#prefix__paint0_linear_1630_2668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.563 69.361c-.361 0-.654-.375-.654-.838v-8.38c0-.463.293-.838.654-.838.361 0 .654.375.654.838v8.38c0 .463-.293.838-.654.838zM107.563 56.791c-.361 0-.654-.375-.654-.838v-8.38c0-.463.293-.838.654-.838.361 0 .654.375.654.838v8.38c0 .463-.293.838-.654.838zM107.563 44.22c-.361 0-.654-.375-.654-.837v-8.38c0-.464.293-.839.654-.839.361 0 .654.375.654.838v8.38c0 .463-.293.839-.654.839zM107.563 31.65c-.361 0-.654-.375-.654-.838v-8.38c0-.463.293-.838.654-.838.361 0 .654.375.654.838v8.38c0 .463-.293.838-.654.838z",
    fill: "#D5DDEA"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.756,
    y: 26.828,
    width: 77.867,
    height: 2.617,
    rx: 1.309,
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.756,
    y: 34.026,
    width: 52.348,
    height: 2.617,
    rx: 1.309,
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.756,
    y: 47.768,
    width: 35.989,
    height: 2.617,
    rx: 1.309,
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.756,
    y: 53.656,
    width: 35.989,
    height: 2.617,
    rx: 1.309,
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.756,
    y: 59.546,
    width: 35.989,
    height: 2.617,
    rx: 1.309,
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5DDEA",
    d: "M114.761 26.174h26.174v3.272h-26.174zM114.761 50.385h26.174v3.272h-26.174zM114.761 31.409h26.174v9.815h-26.174zM114.761 55.619h26.174v9.815h-26.174zM114.761 43.187h26.174v5.235h-26.174z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.046,
    cy: 5.235,
    r: 2.617,
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.461,
    cy: 5.889,
    r: 3.272,
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.189,
    cy: 95.535,
    r: 5.889,
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.65,
    cy: 9.16,
    r: 3.926,
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.138,
    cy: 82.121,
    r: 17.34,
    fill: "url(#prefix__paint1_linear_1630_2668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65 82.728l6.543 6.544L140.28 75.25",
    stroke: "#fff",
    strokeWidth: 3.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_1630_2668",
    x1: 8.535,
    y1: 71.998,
    x2: 7.607,
    y2: 22.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_1630_2668",
    x1: 144.451,
    y1: 67.257,
    x2: 114.174,
    y2: 100.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F3A2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1630_2668"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25)",
    d: "M0 0h150.5v104.696H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__filter0_dd_1630_2668",
    x: -9.565,
    y: 14.396,
    width: 170.13,
    height: 94.226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.617,
    in: "SourceAlpha",
    result: "effect1_dropShadow_1630_2668"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.617
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1630_2668"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.617,
    in: "SourceAlpha",
    result: "effect2_dropShadow_1630_2668"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.087
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.852
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1630_2668",
    result: "effect2_dropShadow_1630_2668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1630_2668",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.443ec1b5bd1d1b641b7157deee32752b.svg";